export default function CornerOrnament({ size = 20, color = 'rgba(180,145,40,0.25)', offset = '8px' }) {
  const style = (pos) => ({ position: 'absolute', pointerEvents: 'none', ...pos });
  return (
    <>
      <svg style={style({ top: offset, left: offset })} width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill="none">
        <path d={`M0 ${size}V0h${size}`} stroke={color} strokeWidth="1" />
      </svg>
      <svg style={style({ top: offset, right: offset })} width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill="none">
        <path d={`M${size} ${size}V0H0`} stroke={color} strokeWidth="1" />
      </svg>
      <svg style={style({ bottom: offset, left: offset })} width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill="none">
        <path d={`M0 0v${size}h${size}`} stroke={color} strokeWidth="1" />
      </svg>
      <svg style={style({ bottom: offset, right: offset })} width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill="none">
        <path d={`M${size} 0v${size}H0`} stroke={color} strokeWidth="1" />
      </svg>
    </>
  );
}
